import type { BasketItem } from "@nwt/norce-pwa/dist/runtime/types/api/shopping/basket";

export const isShippingItem = (item: Partial<BasketItem> | undefined) => {
	if (!item) return false;

	const manufacturerName = item.ManufacturerName?.toLowerCase();
	const name = item.Name?.toLowerCase();
	const uniqueName = item.UniqueName?.toLowerCase();

	return (
		manufacturerName === "freight" ||
		manufacturerName === "frakt" ||
		name === "shipping" ||
		uniqueName === "shipping" ||
		name === "frakt" ||
		uniqueName === "frakt" ||
		uniqueName === "test"
	);
};
